const setPortfolioManagementStatistic = objective => {
  let statistic;
  switch (objective) {
    case 'ManagedRisk':
    case 'PortfolioSeries':
      statistic = 'PSC_N';
      break;
    case 'RetirementTargetDate':
      statistic = 'TDSC_N';
      break;
    default:
      statistic = 'portMgrName';
      break;
  }
  return statistic;
};

const mutations = {
  SET_FUND_ATTRIBUTES(stateCurrent, payload) {
    stateCurrent.fundAttributes = payload.fund;
    stateCurrent.strategies = payload.allFundClass;
    stateCurrent.universeAvailableShareClasses = payload.allClass;

    const objective = stateCurrent.fundAttributes && stateCurrent.fundAttributes.Objective && stateCurrent.fundAttributes.Objective;
    stateCurrent.portfolioManagementStatistic = setPortfolioManagementStatistic(objective);
  }
};

const getters = {
  getFundAttributes: stateCurrent => stateCurrent.fundAttributes,
  getPortfolioManagementStatistic: stateCurrent => stateCurrent.portfolioManagementStatistic,
  isManagedRisk: stateCurrent => stateCurrent.fundAttributes && stateCurrent.fundAttributes.Objective && stateCurrent.fundAttributes.Objective.toLowerCase().includes('managedrisk'),
  isAFISTargetDate: stateCurrent => stateCurrent.fundAttributes && stateCurrent.fundAttributes.Objective && stateCurrent.fundAttributes.Objective.toLowerCase().includes('targetdate'),
  strategies: stateCurrent => stateCurrent.strategies,
  universeAvailableShareClasses: stateCurrent => stateCurrent.universeAvailableShareClasses
};

const state = {
  universeAvailableShareClasses: null,
  strategies: null,
  fundAttributes: null,
  portfolioManagementStatistic: null
};

export default {
  setPortfolioManagementStatistic,
  mutations,
  getters,
  state
};
